import React from "react";

export const stopPropagation = (e: React.MouseEvent) => e.stopPropagation();
